import { render, staticRenderFns } from "./BikyConfigPersonalitySummary.vue?vue&type=template&id=18a08826&scoped=true&"
import script from "./BikyConfigPersonalitySummary.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigPersonalitySummary.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigPersonalitySummary.vue?vue&type=style&index=0&id=18a08826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a08826",
  null
  
)

export default component.exports